.testSettings {
  position: fixed;
  right: 24px;
  bottom: 30px;
  z-index: 9999999;
}

.progressBtnCircle {
  border-color: #95de64 !important;
  background: #95de64 !important;
  -webkit-animation: pulse 1.5s infinite;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(149, 222, 100, 0.5);

  &:hover {
    text-decoration: none;
    border-color: #73d13d !important;
    background: #73d13d !important;
    color: black;
    -webkit-animation: none;
  }

  &[disabled] {
    color: #b2bec3;
    border-color: #dfe6e9 !important;
    background: #f7fafc !important;
    text-shadow: none;
    box-shadow: none;
  }
}

.warningBtn {
  border-color: #795700;
  background: #ffc212;
  border-radius: 7px;
  padding: 4px 16px;

  &:hover,
  &:focus {
    border-color: #333030d1;
    background: #ffbd02e8;
  }
}

.warningBtnCircle {
  border-color: rgba(255, 194, 18, 0.96) !important;
  background: rgba(255, 194, 18, 0.96) !important;
  border-radius: 50%;

  &:hover {
    text-decoration: none;
    border-color: #fdbc02 !important;
    background: #fdbc02 !important;
    color: black;
  }

  &[disabled] {
    color: #b2bec3;
    border-color: #dfe6e9 !important;
    background: #f7fafc !important;
    text-shadow: none;
    box-shadow: none;
  }
}
